module.exports = __webpack_public_path__ + "media/images/lb/001-d6f3745ae2ecc934746038d04fb65744.svg";